function n(n,t,e,l){var o,r;return null!==(r=null!==(o=n.get(t))&&void 0!==o?o:n.get(e))&&void 0!==r?r:l}export{n as getWithDefault};
